

















import { Component, Watch, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { TaskContent } from '../Classes/Entities/Chat/TaskContent';
import NoteThreadChats from '../components/note/NoteThreadChats.vue';
import NoteThreadChatForm from '../components/note/NoteThreadChatForm.vue';

const namespace: string = 'functions';

@Component({
  components: {
    NoteThreadChats,
    NoteThreadChatForm
  },
})
export default class NoteThread extends Vue {
  @State('functions') 
  public functions!: FunctionsState;

  @Getter('functionMap', { namespace }) 
  public functionMap!: Functions;

  @Mutation('getKeys', { namespace }) 
  public getKeys!: any;

  public get task():Post {
    const functionId:string = this.$route.params.function_id;
    const taskId:string = this.$route.params.task_id;
    const func:Function<Post> = this.functionMap.get(functionId);
    const task:Post  = func.postList.get(taskId);
    return task;
  }

  public get thread():Post {
    const threadId:string = this.$route.params.thread_id;
    const task:Post  = this.task
    const thread:Post  = task.postList.get(threadId);
    return thread;
  }
}
